import _ from 'lodash'
import React from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

import styles from './styles'

export default ({
  children,
  className,
  color = 'primary',
  disabled,
  fullWidth = false,
  loading,
  onClick = () => {},
  type,
  variant = 'contained',
  title,
}) => {
  const classes = styles()

  const onClickDebounce = _.debounce(onClick, 1000, {
    leading: true,
    trailing: false,
  })

  return (
    <div className={classes.root}>
      {loading ? (
        <CircularProgress />
      ) : (
        <Button
          className={className}
          color={color}
          disabled={disabled || loading}
          disableElevation={true}
          fullWidth={fullWidth}
          onClick={
            !disabled && !loading && _.isFunction(onClick)
              ? onClickDebounce
              : null
          }
          type={type}
          title={title}
          variant={variant}
          sx={{ borderRadius: 0 }}
        >
          {children}
        </Button>
      )}
    </div>
  )
}
